import BaseAPIService from '../base/base-api-service';
import HandlerModel from 'src/model/handler.model';
import env from 'src/shared/env';

class HandlerService extends BaseAPIService<HandlerModel> {
  public baseURL: string = env.REACT_APP_BASE_API_URL;
  public endpoint: string = '/accountapp/v1';

  constructor() {
    super(HandlerModel);
  }

  public getHandlers(): Promise<HandlerModel[]> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      url: `${this.endpoint}/handler`
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }
}

const handlerServiceInstance = new HandlerService();
Object.freeze(handlerServiceInstance);

export default handlerServiceInstance;
